import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {
  Select,
  MenuItem,
} from '@material-ui/core'

import * as AlertRulesActionCreators from '../../actions/alertRule'

class AlertTypeSelectContainer extends React.Component {
  static propTypes = {
    rule: PropTypes.object.isRequired,
    alertTypes: PropTypes.array.isRequired,
    alertRuleActions: PropTypes.object.isRequired,
  }

  static mapStateToProps(state) {
    return {
      alertTypes: state.alertTypes,
    }
  }

  static mapDispatchToProps(dispatch) {
    return {
      alertRuleActions: bindActionCreators(AlertRulesActionCreators, dispatch),
    }
  }

  componentDidMount() {
    const { alertRuleActions } = this.props
    alertRuleActions.listAlertTypes()
  }

  render() {
    const {
      rule, alertTypes, alertRuleActions,
      ...props
    } = this.props
    return (
      <Select
        value={rule.type}
        {...props}
      >
        {alertTypes.map((type) => (
          <MenuItem key={type} value={type}>
            {type}
          </MenuItem>
        ))}
      </Select>
    )
  }
}

export default connect(
  AlertTypeSelectContainer.mapStateToProps,
  AlertTypeSelectContainer.mapDispatchToProps,
)(AlertTypeSelectContainer)
